import { render } from "./QRScanner3.vue?vue&type=template&id=c22b5232&scoped=true"
import script from "./QRScanner3.vue?vue&type=script&lang=js"
export * from "./QRScanner3.vue?vue&type=script&lang=js"

import "./QRScanner3.vue?vue&type=style&index=0&id=c22b5232&scoped=true&lang=css"
import "./QRScanner3.vue?vue&type=style&index=1&id=c22b5232&scoped=true&lang=css"

import exportComponent from "/Users/aml/Projects/dashboardcopy2/fnbxv21-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c22b5232"]])

export default __exports__